// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1dP0p","subheader":"ReorderModal_subheader__137SD","listWrap":"ReorderModal_listWrap__1WILP"};